module.exports = __webpack_public_path__ + "static/img/oldmanmap.04e8908c.png";